import { FactoryVerificationStep } from '@/types/LocationVerification.type';

export type FactoryVerificationStepRailState = 'upcoming' | 'active' | 'complete';

export type FactoryVerificationUserStepStates = {
  step1State: FactoryVerificationStepRailState;
  step2State: FactoryVerificationStepRailState;
};

export function resolveUserStepStates(
  step: FactoryVerificationStep
): FactoryVerificationUserStepStates {
  switch (step) {
    case 'entrance':
      return { step1State: 'active', step2State: 'upcoming' };
    case 'saved':
      return { step1State: 'complete', step2State: 'upcoming' };
    case 'room':
      return { step1State: 'complete', step2State: 'active' };
    case 'complete':
      return { step1State: 'complete', step2State: 'complete' };
    default:
      return { step1State: 'active', step2State: 'upcoming' };
  }
}

export function isFactoryVerificationUserStepOne(step: FactoryVerificationStep): boolean {
  return step === 'entrance' || step === 'saved';
}
